import cn from 'classnames';
import React from 'react';
import {Link as ReactLink} from 'react-router-dom';

const Link = (props) => {
    const {
        className,
        isExternalLink,
        value,
        to,
        onClick,
        children,
        isTargetBlank,
        testId,
        ariaLabel,
        disabled,
        ariaPressed,
        tabIndex,
    } = props;
    const Component = to ? ReactLink : 'button';
    const target = isTargetBlank ? '_blank' : null;

    return isExternalLink ? (
        <a
            className={cn(className)}
            href={to}
            onClick={onClick}
            rel={isTargetBlank ? 'noopener noreferrer nofollow' : null}
            target={target}
            data-testid={testId}
            aria-label={ariaLabel}
        >
            {children || value}
        </a>
    ) : (
        <Component
            className={cn(className)}
            onClick={onClick}
            rel={isTargetBlank ? 'noopener noreferrer nofollow' : null}
            target={target}
            to={to}
            data-testid={testId}
            aria-label={ariaLabel}
            aria-disabled={disabled}
            aria-pressed={ariaPressed}
            tabIndex={tabIndex}
        >
            {children || value}
        </Component>
    );
};

Link.defaultProps = {
    className: '',
    isExternalLink: false,
    isTargetBlank: false,
};

export default Link;
